import { get, post, postForm, request } from "./request.js";

// 记录点击量
export function clickRecord(params) {
  return get(`/plus-cloud-interact-app/clickAndShare/clickRecord`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// 获取页面互动按钮
export function queryOperateBtn(params) {
  return get(`/plus-cloud-interact-app/tagBtnRecord/queryOperateBtn`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// 根据operacteId查询评论
export function queryAllComments(params) {
  return get(`/plus-cloud-interact-app/comments/queryAllComments`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// 获取稿件详情
export function previewArticle(id) {
  return get(`/gzbn-cloud-manuscript-app/app/article/plusDetail/${id}`)
    .then((res) => res.data)
    .catch((e) => e);
}

// 根据Id查询图集
export function queryCollectionById(params) {
  return get(`/plus-cloud-manage-app/collection/queryCollectionById`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// 查询图集列表
export function queryByCollectionIdList(params) {
  return get(`/plus-cloud-manage-app/collection/queryByCollectionIdList`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// 查询视频号
export function getCount(params) {
  return get(`/plus-cloud-manage-app/publish/getCount`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// 视频号视频列表
export function getVideo(params) {
  return get(`/plus-cloud-manage-app/publish/getVideo`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// 视频号文章列表
export function queryPublishArticles(data) {
  return post(`gzbn-cloud-manuscript-app/app/article/platform/queryPublishArticles`, data)
    .then((res) => res)
    .catch((e) => e);
}

// 视频号直播列表
export function getLiveRoom(params) {
  return get(`plus-cloud-manage-app/publish/getLiveRoom`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// 频道直播详情
export function getChannelLiveDetail(params) {
  return get(`/plus-cloud-interact-app/liveRoom/getDetail`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// 课堂详情
export function queryLessonDetail(params) {
  return get(`/plus-cloud-manage-app/lessonApp/queryLessonDetail`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// 课堂单元详情列表
export function queryLessonHourList(params) {
  return get(`/plus-cloud-manage-app/lessonApp/queryLessonHourList`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// 查询视频
export function getVideoById(params) {
  return get(`/plus-cloud-manage-app/video/getVideoById`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// 查询评论个数
export function getCommentCount(params) {
  return get(`/plus-cloud-interact-app/comments/getCommentCount`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// 查询专题信息
export function getTopicData(params) {
  return get(`/plus-cloud-manage-app/topic/queryTopicById`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// 查询专题二级分类
export function queryTopicByTopicTag(params) {
  return get(`/plus-cloud-manage-app/topic/queryTopicByTopicTag`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// 点赞
export function thumbs(params) {
  return get(`/plus-cloud-interact-app/clickAndShare/outSidePraise`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// 电视频道列表
export function queryProgramList(params) {
  return get(`/plus-cloud-manage-app/liveChannel/queryLiveChannelList`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// 直播节目单
export function queryProgramMenu(params) {
  return get(`/plus-cloud-manage-app/liveChannel/queryLiveChannelMenu`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// 生成证书
export function genPic(params) {
  return post(`/plus-cloud-interact-app/liveRoom/saveOrUpdateRoomCertificate`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

// export function getCookie(params) {
//   return get(`/gzbn-auth/auth/getCookie`, params);
// }

export function getCookie(params) {
  // return request(`/gzbn-auth/auth/getCookie`, params, { withCredentials: true });
  return get(`/gzbn-auth/auth/getCookie`, params, { withCredentials: true })
    .then((res) => res)
    .catch((e) => e);
}

export function dailyOutRecord(params) {
  // return request(`/gzbn-auth/auth/getCookie`, params, { withCredentials: true });
  return post(`/plus-cloud-interact-app/app/dailyOutRecord/save`, params, { withCredentials: true })
    .then((res) => res)
    .catch((e) => e);
}

export function getTopicPictures(params) {
  return get(`/plus-cloud-interact-app/liveRoom/pictures`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

export function clickCountPictures(id) {
  return post(`/plus-cloud-interact-app/liveRoom/read/picture/times/add/${id}`, { id: id })
    .then((res) => res.data)
    .catch((e) => e);
}
